import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
export interface Project {
  name: string,
  img: string,
  progress: number
}
@Component({
  selector: 'app-project-detail',
  templateUrl: './project-detail.component.html',
  styleUrls: ['./project-detail.component.css']
})
export class ProjectDetailComponent implements OnInit {

  @Input() project!: Project
  @ViewChild("input", { static: false }) input!: ElementRef;
  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    setTimeout(() => this.input.nativeElement.focus(), 0);
  }

  ngAfterViewInit() {
    // this.input.nativeElement.focus();
    // if the above is done in a setTimeout, it no longer scrolls
    setTimeout(() => this.input.nativeElement.focus(), 0);
  }

}
